import { render, staticRenderFns } from "./range-slider.vue?vue&type=template&id=b8ed0b9a&"
import script from "./range-slider.vue?vue&type=script&lang=js&"
export * from "./range-slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports